import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
 import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExpensesService {

  
  url = environment.serverAPI5 + "/api/expenses"; 

  
  constructor(private http: HttpClient) { }

  getAllExpenses(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getExpensesById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }
  addOrEditExpenses(expenses: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, expenses);
  }

  ExpensesSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteImage(data: any): Observable<Object> {
		return this.http.post(`${this.url}/deleteImage`, data);
	}

  downloadReportTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, {responseType: 'arraybuffer',observe: 'response' });
  }

  downloadReport() {
    return this.http.get(`${this.url}/exceltemplate/export`, {responseType: 'arraybuffer',observe: 'response' });
  }


  getExpensesData(): Observable<Object> {
		return this.http.get(`${this.url}/products`);
	}

	saveExpenses(products: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}/products`, products);
	}
  deleteById(): Observable<Object> {
		return this.http.delete(`${this.url}`);
	}

  deleteByExpensesId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/${id}`);
	}
  downloadExpensesTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, {responseType: 'arraybuffer',observe: 'response' });
  }


  downloadExpensesReport(Page: number, size: number, sort,selectionExpenses): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionExpenses, { 
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }


  searchExpensesReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }
}

